import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay'
import { CommonModule, registerLocaleData } from '@angular/common'
import { HTTP_INTERCEPTORS, HttpBackend, HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http'
import localePt from '@angular/common/locales/pt'
import { LOCALE_ID, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { NgxChartsModule } from '@swimlane/ngx-charts'
import { AlertModule, AuthGuard, CONSTANTS, ENV, HttpErrorInterceptor, JwtService, SharedModule, customHttpProvider } from 'lib-trend-core'
import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask'
import { GlobalConfig, ToastrModule } from 'ngx-toastr'
import { Constants } from '../environments/constantes'
import { environment } from '../environments/environment'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { MultiTranslateHttpLoader } from './i18n/multi-translate-http-loader'
import { DashboardModule } from './modules/dashboard/dashboard.module'
import { InfoModule } from './modules/info/info.module'
import { LayoutModule } from './modules/layout/layout.module'
import { WebhookModule } from './modules/webhook/webhook.module'

const maskConfig: Partial<NgxMaskConfig> = {
  validation: false,
}

const toastGlobalConfig: Partial<GlobalConfig> = {
  preventDuplicates: true,
  maxOpened: 3,
}

registerLocaleData(localePt)

// The admin stays pt-BR only; TranslateModule is still required because shared
// lib-trend-core components (AbstractComponent, translate pipes) depend on it.
export function httpTranslateLoaderFactory(handler: HttpBackend): TranslateLoader {
  return new MultiTranslateHttpLoader(new HttpClient(handler), [
    { prefix: './assets/i18n/', suffix: '.json' },
    { prefix: './assets/i18n/lib-core.', suffix: '.json' },
  ])
}

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forRoot({
            defaultLanguage: 'pt-BR',
            useDefaultLang: true,
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoaderFactory,
                deps: [HttpBackend],
            },
        }),
        AppRoutingModule,
        NgxChartsModule,
        LayoutModule,
        SharedModule,
        DashboardModule,
        AlertModule,
        InfoModule,
        WebhookModule,
        ToastrModule.forRoot(toastGlobalConfig)], providers: [
        AuthGuard,
        provideEnvironmentNgxMask(maskConfig),
        { provide: LOCALE_ID, useValue: 'pt' },
        { provide: HTTP_INTERCEPTORS, useClass: JwtService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        { provide: ENV, useValue: environment },
        { provide: CONSTANTS, useValue: Constants },
        // CDK 21 renders overlays in the browser top layer by default; keeping them in the overlay
        // container lets SweetAlert2 and toasts still stack above Material dialogs.
        { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
        provideAnimationsAsync(),
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        // After provideHttpClient: the last HttpClient provider wins, and it must be CustomHttp.
        customHttpProvider,
    ] })
export class AppModule { }
